import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SystemAutoRefreshService } from '@app/core/services/internal/system-auto-refresh.service';
import { NgIf } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
    selector: 'app-system-refresh-countdown',
    templateUrl: './system-refresh-countdown.component.html',
    styleUrls: ['./system-refresh-countdown.component.scss'],
    imports: [NgIf, IonicModule],
})
export class SystemRefreshCountdownComponent implements OnInit, OnDestroy {
  visible = false;
  display = '5:00';
  isUrgent = false;

  private sub?: Subscription;

  constructor(private autoRefresh: SystemAutoRefreshService) {}

  ngOnInit(): void {
    this.sub = this.autoRefresh.remaining$.subscribe((remaining) => {
      if (remaining === null) {
        this.visible = false;
        return;
      }
      this.visible = true;
      this.display = this.format(remaining);
      this.isUrgent = remaining <= 60 * 1000;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private format(ms: number): string {
    const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
}
